
const timeOfDayEventsData = [
    { index: 0, day: "Sun", hour: '12am', value: 20 },
    { index: 0, day: "Sun", hour: '1am', value: 32 },
    { index: 0, day: "Sun", hour: '2am', value: 40 },
    { index: 0, day: "Sun", hour: '3am', value: 50 },
    { index: 0, day: "Sun", hour: '4am', value: 55 },
    { index: 0, day: "Sun", hour: '5am', value: 60 },
    { index: 0, day: "Sun", hour: '6am', value: 70 },
    { index: 0, day: "Sun", hour: '7am', value: 75 },
    { index: 0, day: "Sun", hour: '8am', value: 80 },
    { index: 0, day: "Sun", hour: '9am', value: 85 },
    { index: 0, day: "Sun", hour: '10am', value: 90 },
    { index: 0, day: "Sun", hour: '11am', value: 95 },
    { index: 0, day: "Sun", hour: '12pm', value: 100 },
    { index: 0, day: "Sun", hour: '1pm', value: 105 },
    { index: 0, day: "Sun", hour: '2pm', value: 130 },
    { index: 0, day: "Sun", hour: '3pm', value: 145 },
    { index: 0, day: "Sun", hour: '4pm', value: 160 },
    { index: 0, day: "Sun", hour: '5pm', value: 165 },
    { index: 0, day: "Sun", hour: '6pm', value: 170 },
    { index: 0, day: "Sun", hour: '7pm', value: 175 },
    { index: 0, day: "Sun", hour: '8pm', value: 180 },
    { index: 0, day: "Sun", hour: '9pm', value: 193 },
    { index: 0, day: "Sun", hour: '10pm', value: 202 },
    { index: 0, day: "Sun", hour: '11pm', value: 220 },
    { index: 1, day: "Mon", hour: '12am', value: 20 },
    { index: 1, day: "Mon", hour: '1am', value: 32 },
    { index: 1, day: "Mon", hour: '2am', value: 40 },
    { index: 1, day: "Mon", hour: '3am', value: 50 },
    { index: 1, day: "Mon", hour: '4am', value: 55 },
    { index: 1, day: "Mon", hour: '5am', value: 60 },
    { index: 1, day: "Mon", hour: '6am', value: 70 },
    { index: 1, day: "Mon", hour: '7am', value: 75 },
    { index: 1, day: "Mon", hour: '8am', value: 80 },
    { index: 1, day: "Mon", hour: '9am', value: 85 },
    { index: 1, day: "Mon", hour: '10am', value: 90 },
    { index: 1, day: "Mon", hour: '11am', value: 95 },
    { index: 1, day: "Mon", hour: '12pm', value: 100 },
    { index: 1, day: "Mon", hour: '1pm', value: 105 },
    { index: 1, day: "Mon", hour: '2pm', value: 110 },
    { index: 1, day: "Mon", hour: '3pm', value: 115 },
    { index: 1, day: "Mon", hour: '4pm', value: 120 },
    { index: 1, day: "Mon", hour: '5pm', value: 125 },
    { index: 1, day: "Mon", hour: '6pm', value: 130 },
    { index: 1, day: "Mon", hour: '7pm', value: 145 },
    { index: 1, day: "Mon", hour: '8pm', value: 152 },
    { index: 1, day: "Mon", hour: '9pm', value: 159 },
    { index: 1, day: "Mon", hour: '10pm', value: 162 },
    { index: 1, day: "Mon", hour: '11pm', value: 180 },
    { index: 2, day: "Tues", hour: '12am', value: 20 },
    { index: 2, day: "Tues", hour: '1am', value: 32 },
    { index: 2, day: "Tues", hour: '2am', value: 40 },
    { index: 2, day: "Tues", hour: '3am', value: 50 },
    { index: 2, day: "Tues", hour: '4am', value: 55 },
    { index: 2, day: "Tues", hour: '5am', value: 60 },
    { index: 2, day: "Tues", hour: '6am', value: 70 },
    { index: 2, day: "Tues", hour: '7am', value: 75 },
    { index: 2, day: "Tues", hour: '8am', value: 80 },
    { index: 2, day: "Tues", hour: '9am', value: 85 },
    { index: 2, day: "Tues", hour: '10am', value: 90 },
    { index: 2, day: "Tues", hour: '11am', value: 95 },
    { index: 2, day: "Tues", hour: '12pm', value: 100 },
    { index: 2, day: "Tues", hour: '1pm', value: 105 },
    { index: 2, day: "Tues", hour: '2pm', value: 110 },
    { index: 2, day: "Tues", hour: '3pm', value: 115 },
    { index: 2, day: "Tues", hour: '4pm', value: 120 },
    { index: 2, day: "Tues", hour: '5pm', value: 125 },
    { index: 2, day: "Tues", hour: '6pm', value: 130 },
    { index: 2, day: "Tues", hour: '7pm', value: 145 },
    { index: 2, day: "Tues", hour: '8pm', value: 160 },
    { index: 2, day: "Tues", hour: '9pm', value: 179 },
    { index: 2, day: "Tues", hour: '10pm', value: 182 },
    { index: 2, day: "Tues", hour: '11pm', value: 190 },
    { index: 3, day: "Wed", hour: '12am', value: 20 },
    { index: 3, day: "Wed", hour: '1am', value: 32 },
    { index: 3, day: "Wed", hour: '2am', value: 40 },
    { index: 3, day: "Wed", hour: '3am', value: 50 },
    { index: 3, day: "Wed", hour: '4am', value: 55 },
    { index: 3, day: "Wed", hour: '5am', value: 60 },
    { index: 3, day: "Wed", hour: '6am', value: 70 },
    { index: 3, day: "Wed", hour: '7am', value: 75 },
    { index: 3, day: "Wed", hour: '8am', value: 80 },
    { index: 3, day: "Wed", hour: '9am', value: 85 },
    { index: 3, day: "Wed", hour: '10am', value: 90 },
    { index: 3, day: "Wed", hour: '11am', value: 95 },
    { index: 3, day: "Wed", hour: '12pm', value: 100 },
    { index: 3, day: "Wed", hour: '1pm', value: 105 },
    { index: 3, day: "Wed", hour: '2pm', value: 110 },
    { index: 3, day: "Wed", hour: '3pm', value: 115 },
    { index: 3, day: "Wed", hour: '4pm', value: 120 },
    { index: 3, day: "Wed", hour: '5pm', value: 125 },
    { index: 3, day: "Wed", hour: '6pm', value: 130 },
    { index: 3, day: "Wed", hour: '7pm', value: 135 },
    { index: 3, day: "Wed", hour: '8pm', value: 140 },
    { index: 3, day: "Wed", hour: '9pm', value: 139 },
    { index: 3, day: "Wed", hour: '10pm', value: 190 },
    { index: 3, day: "Wed", hour: '11pm', value: 200 },
    { index: 4, day: "Thurs", hour: '12am', value: 20 },
    { index: 4, day: "Thurs", hour: '1am', value: 32 },
    { index: 4, day: "Thurs", hour: '2am', value: 40 },
    { index: 4, day: "Thurs", hour: '3am', value: 50 },
    { index: 4, day: "Thurs", hour: '4am', value: 55 },
    { index: 4, day: "Thurs", hour: '5am', value: 60 },
    { index: 4, day: "Thurs", hour: '6am', value: 70 },
    { index: 4, day: "Thurs", hour: '7am', value: 75 },
    { index: 4, day: "Thurs", hour: '8am', value: 80 },
    { index: 4, day: "Thurs", hour: '9am', value: 85 },
    { index: 4, day: "Thurs", hour: '10am', value: 90 },
    { index: 4, day: "Thurs", hour: '11am', value: 95 },
    { index: 4, day: "Thurs", hour: '12pm', value: 100 },
    { index: 4, day: "Thurs", hour: '1pm', value: 105 },
    { index: 4, day: "Thurs", hour: '2pm', value: 110 },
    { index: 4, day: "Thurs", hour: '3pm', value: 115 },
    { index: 4, day: "Thurs", hour: '4pm', value: 120 },
    { index: 4, day: "Thurs", hour: '5pm', value: 135 },
    { index: 4, day: "Thurs", hour: '6pm', value: 140 },
    { index: 4, day: "Thurs", hour: '7pm', value: 155 },
    { index: 4, day: "Thurs", hour: '8pm', value: 160 },
    { index: 4, day: "Thurs", hour: '9pm', value: 175 },
    { index: 4, day: "Thurs", hour: '10pm', value: 185 },
    { index: 4, day: "Thurs", hour: '11pm', value: 195 },
    { index: 5, day: "Fri", hour: '12am', value: 20 },
    { index: 5, day: "Fri", hour: '1am', value: 32 },
    { index: 5, day: "Fri", hour: '2am', value: 40 },
    { index: 5, day: "Fri", hour: '3am', value: 50 },
    { index: 5, day: "Fri", hour: '4am', value: 55 },
    { index: 5, day: "Fri", hour: '5am', value: 60 },
    { index: 5, day: "Fri", hour: '6am', value: 70 },
    { index: 5, day: "Fri", hour: '7am', value: 75 },
    { index: 5, day: "Fri", hour: '8am', value: 80 },
    { index: 5, day: "Fri", hour: '9am', value: 85 },
    { index: 5, day: "Fri", hour: '10am', value: 90 },
    { index: 5, day: "Fri", hour: '11am', value: 95 },
    { index: 5, day: "Fri", hour: '12pm', value: 100 },
    { index: 5, day: "Fri", hour: '1pm', value: 105 },
    { index: 5, day: "Fri", hour: '2pm', value: 110 },
    { index: 5, day: "Fri", hour: '3pm', value: 125 },
    { index: 5, day: "Fri", hour: '4pm', value: 130 },
    { index: 5, day: "Fri", hour: '5pm', value: 145 },
    { index: 5, day: "Fri", hour: '6pm', value: 150 },
    { index: 5, day: "Fri", hour: '7pm', value: 155 },
    { index: 5, day: "Fri", hour: '8pm', value: 160 },
    { index: 5, day: "Fri", hour: '9pm', value: 169 },
    { index: 5, day: "Fri", hour: '10pm', value: 172 },
    { index: 5, day: "Fri", hour: '11pm', value: 180 },
    { index: 6, day: "Sat", hour: '12am', value: 20 },
    { index: 6, day: "Sat", hour: '1am', value: 32 },
    { index: 6, day: "Sat", hour: '2am', value: 40 },
    { index: 6, day: "Sat", hour: '3am', value: 50 },
    { index: 6, day: "Sat", hour: '4am', value: 55 },
    { index: 6, day: "Sat", hour: '5am', value: 60 },
    { index: 6, day: "Sat", hour: '6am', value: 70 },
    { index: 6, day: "Sat", hour: '7am', value: 75 },
    { index: 6, day: "Sat", hour: '8am', value: 80 },
    { index: 6, day: "Sat", hour: '9am', value: 85 },
    { index: 6, day: "Sat", hour: '10am', value: 90 },
    { index: 6, day: "Sat", hour: '11am', value: 95 },
    { index: 6, day: "Sat", hour: '12pm', value: 100 },
    { index: 6, day: "Sat", hour: '1pm', value: 105 },
    { index: 6, day: "Sat", hour: '2pm', value: 110 },
    { index: 6, day: "Sat", hour: '3pm', value: 115 },
    { index: 6, day: "Sat", hour: '4pm', value: 130 },
    { index: 6, day: "Sat", hour: '5pm', value: 135 },
    { index: 6, day: "Sat", hour: '6pm', value: 140 },
    { index: 6, day: "Sat", hour: '7pm', value: 155 },
    { index: 6, day: "Sat", hour: '8pm', value: 160 },
    { index: 6, day: "Sat", hour: '9pm', value: 175 },
    { index: 6, day: "Sat", hour: '10pm', value: 185 },
    { index: 6, day: "Sat", hour: '11pm', value: 195 },
]


export default timeOfDayEventsData;